import type { SentenceToken } from "../game/types";

interface Props {
  token: SentenceToken;
}

const genderGlyph: Record<NonNullable<SentenceToken["gender"]>, string> = {
  M: "♂",
  F: "♀",
  NB: "⚧",
};

export default function Frame({ token }: Props) {
  const classes = ["frame", token.frameColor];
  if (token.plural) classes.push("plural");
  const hasSash = Boolean(token.tense || token.gender || token.negation || token.compoundWithNext);
  return (
    <span className={classes.join(" ")} aria-hidden>
      <span className="frame__order">{token.order}</span>
      {hasSash && (
        <span className="frame__sash">
          {token.tense && <TenseBar tense={token.tense} />}
          {token.gender && <span className="frame__pin">{genderGlyph[token.gender]}</span>}
          {token.negation && <span className="frame__pin frame__pin--neg">✕</span>}
          {token.compoundWithNext && <span className="frame__pin">+</span>}
        </span>
      )}
    </span>
  );
}

function TenseBar({ tense }: { tense: NonNullable<SentenceToken["tense"]> }) {
  return (
    <span className="tense-bar">
      <span className={`tense-bar__dot${tense === "past" ? " active" : ""}`} />
      <span className="tense-bar__line" />
      <span className={`tense-bar__dot${tense === "present" ? " active" : ""}`} />
      <span className="tense-bar__line" />
      <span className={`tense-bar__dot${tense === "future" ? " active" : ""}`} />
    </span>
  );
}
